/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuthHeader } from '../../services/tokenService';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Badge } from '../../components/ui/badge';
import { Button } from '../../components/ui/button';
import { Calculator, AlertCircle, CheckCircle, AlertTriangle, Info, Search, Loader2, Download } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { showFormErrorFeedback } from '../../lib/formFeedback';
import { useAuth } from '../../contexts/AuthContext';
import { useFormValidation } from '../../components/ui/FormField';
import { computeTtcFromHtAndTaxes, normalizeTaxesSource } from '../../lib/computeTtc';
import { useOfflineStatus } from '../../components/OfflineStatusIndicator';
import { API } from './constants';
import FormulaireSection from './FormulaireSection';
import ResultatsSection from './ResultatsSection';
import HeaderSection from './HeaderSection';
import EligibilityProfilePanel from './EligibilityProfilePanel';
import { ContratParentSearch } from './ContratParentSearch';
import { EditContactModal } from '../../components/MembresTable/modals';
import { useOfflineMode } from './useOfflineMode';
import { useContratHandlers } from './useContratHandlers';
import { getToken } from '../../services/tokenService';


export const CalculateurBaticoView = ({ ctx }) => {
  const {
    activitesCompletes, creditCostPdf, currentEcheancierPlan, eligibilityForm, eligibilityResult,
    eligibilityValid, forceValidationLoading, forceValidationTaux, formData, isFtpeMember, loading,
    loadingDevis, loadingRestrictions, membreData, modeCalcul, modeSimulateur, montantsPersonnalises,
    operationNominative, parametresBatico, propositionConversion, remiseSolidaireNegociee, restrictions,
    resultat, resumeMode, resumeParentDevisId, resumeSimulationId, selectedActivites2nd, selectedActivitesGO,
    selectedActivitesPIB, selectedActivitesTP, showProfilModal, taxesPersonnalisees, territoiresIntervention,
    touched, typesOperation, validitePersonnalisee, walletBalance,
    setActivitesCompletes, setCreditCostPdf, setCurrentEcheancierPlan, setEligibilityForm, setEligibilityResult,
    setEligibilityValid, setForceValidationLoading, setForceValidationTaux, setFormData, setIsFtpeMember,
    setLoading, setLoadingDevis, setLoadingRestrictions, setMembreData, setModeCalcul, setModeSimulateur,
    setMontantsPersonnalises, setOperationNominative, setParametresBatico, setPropositionConversion,
    setRemiseSolidaireNegociee, setRestrictions, setResultat, setResumeMode, setResumeParentDevisId,
    setResumeSimulationId, setSelectedActivites2nd, setSelectedActivitesGO, setSelectedActivitesPIB,
    setSelectedActivitesTP, setShowProfilModal, setTaxesPersonnalisees, setTerritoiresIntervention,
    setTouched, setTypesOperation, setValiditePersonnalisee, setWalletBalance,
    user, isOnline, unsyncedCount, navigate, location,
    localSimulations, setLocalSimulations, showLocalSimulations, setShowLocalSimulations, saveToLocal,
    handleLoadLocalSimulation, handleDeleteLocalSimulation,
    referenceRecherche, setReferenceRecherche, contratParent, setContratParent, loadingContrat,
    contratsDisponibles, loadingContrats, erreurContrat, setErreurContrat, handleRechercherContrat,
    handleSelectContrat, handleProcederAuPaiement, handleResetAvenant,
    errors, setError, clearError, validateForm, clearAllErrors,
    ajouterLigneTaxe, canAccessAnnuel, canAccessNominative, fromSouscription, getActivitesSelectionneesFull,
    getDashboardLabel, getDashboardPath, getMontantsFinals, getSeuilCAActif, getTaxesFinals,
    handleActivitesLoaded, handleCalculer, handleCreerAvenant, handleDownloadDevisSimulation, handleProfilSaved,
    handleReset, handleSaveForLater, handleSouscrire, handleSouscrireFromProposition, hasEnoughCredits,
    isAdminOrSuperAdmin, isSuperAdmin, supprimerLigneTaxe, updateLigneTaxe,
  } = ctx;
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <HeaderSection
        isOnline={isOnline} localSimulations={localSimulations}
        showLocalSimulations={showLocalSimulations} setShowLocalSimulations={setShowLocalSimulations}
        getDashboardLabel={getDashboardLabel} getDashboardPath={getDashboardPath}
        modeSimulateur={modeSimulateur} setModeSimulateur={setModeSimulateur}
        membreData={membreData} unsyncedCount={unsyncedCount}
        deleteLocalSimulation={handleDeleteLocalSimulation} setLocalSimulations={setLocalSimulations}
        handleResetAvenant={handleResetAvenant}
        handleLoadLocalSimulation={handleLoadLocalSimulation}
        onCompleteProfil={() => setShowProfilModal(true)}
      />

      {/* V38.01 — Modale d'édition du profil membre (mêmes champs que le
          tableau des membres : CA, effectif, date de création, expérience…) */}
      <EditContactModal
        membre={membreData}
        open={showProfilModal}
        onClose={() => setShowProfilModal(false)}
        onSave={handleProfilSaved}
        token={getToken()}
        userRole={user?.role}
      />

      {/* Bannière contextuelle — Utilisateur redirigé depuis le workflow de souscription */}
      {fromSouscription && (
        <div
          className="bg-gradient-to-r from-amber-100 via-orange-50 to-amber-100 border-y-2 border-amber-300 shadow-sm"
          data-testid="banniere-from-souscription"
        >
          <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-center gap-3 flex-wrap">
            <div className="flex-shrink-0 w-9 h-9 rounded-full bg-amber-500 flex items-center justify-center shadow-md">
              <span className="text-base" aria-hidden="true">📋</span>
            </div>
            <p className="text-sm sm:text-base font-semibold text-amber-900 text-center">
              Vous démarrez une souscription —
              <span className="font-normal text-amber-800"> calculez votre cotisation puis cliquez sur </span>
              <span className="font-bold text-amber-900 underline decoration-amber-400 underline-offset-2">Souscrire</span>.
            </p>
          </div>
        </div>
      )}

        {/* Section Restrictions Actives - Masquée pour les membres et coopers */}
        {/* Les restrictions sont appliquées en backend mais ne sont plus affichées */}

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Formulaire */}
          <Card className="shadow-2xl border-0 ring-2 ring-blue-100/50 overflow-hidden">
            <CardHeader className="relative bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/30 border-b-2 border-blue-100">
              {/* Motif de fond subtil */}
              <div className="absolute inset-0 opacity-5">
                <div className="absolute top-0 right-0 w-40 h-40 bg-blue-700 rounded-full blur-3xl"></div>
              </div>
              
              <div className="relative">
                <div className="flex items-center gap-3 mb-2">
                  <div className="p-2 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-xl">
                    <Calculator className="h-5 w-5 text-white" />
                  </div>
                  <CardTitle className="text-2xl font-bold bg-gradient-to-r from-blue-900 to-indigo-900 bg-clip-text text-transparent">
                    Paramètres de calcul
                  </CardTitle>
                </div>
                <CardDescription className="text-base font-medium text-slate-600 ml-14">
                  Renseignez votre CA et sélectionnez vos activités
                </CardDescription>
              </div>
            </CardHeader>
            <CardContent className="space-y-6">
              
              {/* Section Recherche Contrat Parent - Mode Avenant uniquement */}
              <ContratParentSearch ctx={ctx} />


              {/* Profil d'éligibilité (modulateurs avancés) */}
              <div className="mb-4">
                <EligibilityProfilePanel
                  membre={membreData || user}
                  territoiresCAInitial={modeSimulateur === 'avenant' ? contratParent?.territoires_ca : null}
                  onEligibilityChange={setEligibilityForm}
                  onValidityChange={setEligibilityValid}
                  isSuperAdmin={isSuperAdmin}
                  nombreActivites={
                    selectedActivitesGO.length + selectedActivites2nd.length +
                    selectedActivitesPIB.length + selectedActivitesTP.length
                  }
                />
              </div>

              {/* Formulaire - Composant extrait */}
              <FormulaireSection
                membreData={membreData}
                modeSimulateur={modeSimulateur}
                contratParent={contratParent}
                modeCalcul={modeCalcul}
                setModeCalcul={setModeCalcul}
                canAccessAnnuel={canAccessAnnuel}
                canAccessNominative={canAccessNominative}
                user={user}
                formData={formData}
                setFormData={setFormData}
                operationNominative={operationNominative}
                setOperationNominative={setOperationNominative}
                typesOperation={typesOperation}
                territoiresIntervention={territoiresIntervention}
                setTerritoiresIntervention={setTerritoiresIntervention}
                selectedActivitesGO={selectedActivitesGO}
                setSelectedActivitesGO={setSelectedActivitesGO}
                selectedActivites2nd={selectedActivites2nd}
                setSelectedActivites2nd={setSelectedActivites2nd}
                selectedActivitesPIB={selectedActivitesPIB}
                setSelectedActivitesPIB={setSelectedActivitesPIB}
                selectedActivitesTP={selectedActivitesTP}
                setSelectedActivitesTP={setSelectedActivitesTP}
                handleActivitesLoaded={handleActivitesLoaded}
                activitesCompletes={activitesCompletes}
                errors={errors}
                touched={touched}
                setTouched={setTouched}
                clearError={clearError}
                validitePersonnalisee={validitePersonnalisee}
                setValiditePersonnalisee={setValiditePersonnalisee}
                montantsPersonnalises={montantsPersonnalises}
                setMontantsPersonnalises={setMontantsPersonnalises}
                taxesPersonnalisees={taxesPersonnalisees}
                setTaxesPersonnalisees={setTaxesPersonnalisees}
                getSeuilCAActif={getSeuilCAActif}
                handleCalculer={handleCalculer}
                loading={loading}
                resultat={resultat}
                setResultat={setResultat}
                handleReset={handleReset}
                handleResetAvenant={handleResetAvenant}
                caSyncedFromTerritoires={(() => {
                  const tCA = eligibilityForm?.territoires_ca || {};
                  const total = Object.values(tCA).reduce((s, v) => s + (Number(v) || 0), 0);
                  return total > 0 && String(total) === String(formData.ca_ht);
                })()}
              />
            </CardContent>
          </Card>

              {/* Résultats - Composant extrait */}
              <ResultatsSection
                resultat={resultat}
                modeCalcul={modeCalcul}
                modeSimulateur={modeSimulateur}
                user={user}
                formData={formData}
                contratParent={contratParent}
                walletBalance={walletBalance}
                creditCostPdf={creditCostPdf}
                hasEnoughCredits={hasEnoughCredits}
                loadingDevis={loadingDevis}
                handleDownloadDevisSimulation={handleDownloadDevisSimulation}
                handleSouscrire={handleSouscrire}
                handleCreerAvenant={handleCreerAvenant}
                propositionConversion={propositionConversion}
                handleSouscrireFromProposition={handleSouscrireFromProposition}
                dismissPropositionConversion={handleSaveForLater}
                isFtpeMember={isFtpeMember}
                loading={loading}
                selectedActivitesPIB={selectedActivitesPIB}
                selectedActivitesGO={selectedActivitesGO}
                selectedActivites2nd={selectedActivites2nd}
                selectedActivitesTP={selectedActivitesTP}
                montantsPersonnalises={montantsPersonnalises}
                setMontantsPersonnalises={setMontantsPersonnalises}
                getMontantsFinals={getMontantsFinals}
                getTaxesFinals={getTaxesFinals}
                taxesPersonnalisees={taxesPersonnalisees}
                setTaxesPersonnalisees={setTaxesPersonnalisees}
                isSuperAdmin={isSuperAdmin}
                isAdminOrSuperAdmin={isAdminOrSuperAdmin}
                validitePersonnalisee={validitePersonnalisee}
                setValiditePersonnalisee={setValiditePersonnalisee}
                updateLigneTaxe={updateLigneTaxe}
                supprimerLigneTaxe={supprimerLigneTaxe}
                ajouterLigneTaxe={ajouterLigneTaxe}
                remiseSolidaireNegociee={remiseSolidaireNegociee}
                onEcheancierPlanChange={setCurrentEcheancierPlan}
              />

              {/* V36.65 — Indicateur de qualité de dossier (COOPER / EXPERT uniquement).
                  Remplace le détail technique (scores, motifs) réservé au Super Admin
                  par un signal visuel à 3 niveaux. */}
              {eligibilityResult && !isSuperAdmin && (() => {
                const classe = (eligibilityResult.classe_dossier || '').toUpperCase();
                const statut = (eligibilityResult.statut || '').toUpperCase();
                // Mapping classe → niveau de qualité dossier
                // FAIBLE / STANDARD → solide (peu de friction tarifaire)
                // SENSIBLE → standard (zone neutre)
                // RENFORCE / MAJORATION_PERSONNALISEE / VALIDATION_MANUELLE / REFUS → à renforcer
                let level = 'standard';
                if (statut === 'REFUS') level = 'reinforcer';
                else if (['FAIBLE', 'STANDARD'].includes(classe)) level = 'solide';
                else if (classe === 'SENSIBLE') level = 'standard';
                else if (['RENFORCE', 'MAJORATION_PERSONNALISEE', 'VALIDATION_MANUELLE'].includes(classe)) level = 'reinforcer';

                const meta = {
                  solide: {
                    badge: '🟢',
                    title: 'Dossier solide',
                    text: 'Votre profil correspond aux critères standards. Conditions tarifaires favorables.',
                    border: 'border-emerald-300',
                    bg: 'bg-gradient-to-r from-emerald-50 via-white to-emerald-50',
                    accent: 'text-emerald-700',
                    barColor: 'bg-emerald-500',
                    pct: 90,
                  },
                  standard: {
                    badge: '🟡',
                    title: 'Dossier standard',
                    text: 'Votre profil est éligible. Quelques caractéristiques nécessitent une attention particulière sur le tarif.',
                    border: 'border-amber-300',
                    bg: 'bg-gradient-to-r from-amber-50 via-white to-amber-50',
                    accent: 'text-amber-700',
                    barColor: 'bg-amber-500',
                    pct: 60,
                  },
                  reinforcer: {
                    badge: '🟠',
                    title: 'Dossier à renforcer',
                    text: 'Votre profil présente des spécificités. Vous pouvez nous contacter pour un échange personnalisé sur votre couverture.',
                    border: 'border-orange-300',
                    bg: 'bg-gradient-to-r from-orange-50 via-white to-orange-50',
                    accent: 'text-orange-700',
                    barColor: 'bg-orange-500',
                    pct: 30,
                  },
                }[level];

                return (
                  <div
                    className={`mt-4 border-2 ${meta.border} ${meta.bg} rounded-xl p-4`}
                    data-testid="quality-indicator-card"
                  >
                    <div className="flex items-start gap-3">
                      <div className="text-3xl leading-none flex-shrink-0">{meta.badge}</div>
                      <div className="flex-1 min-w-0">
                        <div className="flex flex-wrap items-center gap-2 mb-1">
                          <h4 className={`text-base font-bold ${meta.accent}`}>
                            {meta.title}
                          </h4>
                          <span className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold bg-white/70 border border-slate-200 rounded-full px-2 py-0.5">
                            Indicateur qualité
                          </span>
                        </div>
                        <p className="text-xs text-slate-600 leading-snug">
                          {meta.text}
                        </p>
                        {/* Barre de progression visuelle 3 segments */}
                        <div className="mt-2.5 flex items-center gap-2">
                          <div className="flex-1 h-1.5 bg-slate-200 rounded-full overflow-hidden" data-testid={`quality-bar-${level}`}>
                            <div
                              className={`${meta.barColor} h-full transition-all duration-500`}
                              style={{ width: `${meta.pct}%` }}
                            />
                          </div>
                          <div className="flex items-center gap-0.5 text-[10px] text-slate-500 font-medium">
                            <span className={level === 'reinforcer' ? meta.accent + ' font-bold' : ''}>🟠</span>
                            <span className={level === 'standard' ? meta.accent + ' font-bold' : ''}>🟡</span>
                            <span className={level === 'solide' ? meta.accent + ' font-bold' : ''}>🟢</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })()}

              {/* Résultat d'éligibilité (modulateurs avancés) — Super Admin uniquement */}
              {eligibilityResult && isSuperAdmin && (
                <div className={`mt-4 border-2 rounded-xl p-5 ${
                  eligibilityResult.statut === 'REFUS' ? 'border-red-300 bg-red-50' :
                  eligibilityResult.statut === 'VALIDATION_MANUELLE' ? 'border-amber-300 bg-amber-50' :
                  'border-emerald-300 bg-emerald-50'
                }`} data-testid="eligibility-result">
                  <div className="flex items-start justify-between gap-3 flex-wrap">
                    <div>
                      <div className="text-sm font-semibold text-slate-700 mb-1">Profil d'éligibilité</div>
                      <div className={`text-lg font-bold ${
                        eligibilityResult.statut === 'REFUS' ? 'text-red-700' :
                        eligibilityResult.statut === 'VALIDATION_MANUELLE' ? 'text-amber-700' :
                        'text-emerald-700'
                      }`}>
                        {eligibilityResult.statut === 'REFUS' ? '❌ Refus' :
                         eligibilityResult.statut === 'VALIDATION_MANUELLE' ? '⚠️ Validation manuelle requise' :
                         '✅ Accepté'}
                      </div>
                      <div className="text-xs text-slate-600 mt-1">
                        Score d'éligibilité : <strong>{eligibilityResult.score_eligibilite}</strong>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="text-xs text-slate-500">Cotisation ajustée</div>
                      <div className="text-2xl font-bold text-slate-900">
                        {eligibilityResult.cotisation_finale.toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €
                      </div>
                      <div className="text-[11px] text-slate-500 mt-0.5">
                        Base : {eligibilityResult.cotisation_base.toLocaleString('fr-FR')} € · Coef ×{eligibilityResult.coef_multiplicatif} · +{eligibilityResult.modulateur_additif_pct}%
                      </div>
                    </div>
                  </div>
                  {eligibilityResult.raisons_blocage?.length > 0 && (
                    <ul className="mt-3 text-sm text-red-700 list-disc pl-5">
                      {eligibilityResult.raisons_blocage.map((r, i) => <li key={i}>{r}</li>)}
                    </ul>
                  )}
                  {eligibilityResult.alertes?.length > 0 && (
                    <ul className="mt-3 text-sm text-amber-700 list-disc pl-5">
                      {eligibilityResult.alertes.map((a, i) => <li key={i}>{a}</li>)}
                    </ul>
                  )}

                  {/* V36.62 — Bloc Super Admin : Forcer la validation + taux personnalisé.
                      Visible seulement quand le statut est REFUS (sinon majoration auto suffit). */}
                  {eligibilityResult.statut === 'REFUS' && !eligibilityResult.details?.refus_overridden_by_super_admin && (
                    <div
                      className="mt-4 border-2 border-violet-300 bg-gradient-to-r from-violet-50 via-white to-purple-50 rounded-lg p-4"
                      data-testid="force-validation-block"
                    >
                      <div className="flex items-start gap-2 mb-3">
                        <div className="w-8 h-8 rounded-md bg-violet-100 flex items-center justify-center flex-shrink-0">
                          <span className="text-violet-700 font-bold text-lg">⚖️</span>
                        </div>
                        <div className="flex-1">
                          <h5 className="text-sm font-bold text-violet-900">
                            Super Admin — Forcer la validation
                          </h5>
                          <p className="text-xs text-slate-600 leading-tight mt-0.5">
                            Le dossier est en <strong>REFUS</strong>. Vous pouvez appliquer un taux
                            de majoration personnalisé qui contourne le refus, ou souscrire en l'état
                            (le statut REFUS sera conservé pour la traçabilité).
                          </p>
                        </div>
                      </div>

                      <div className="flex flex-wrap items-end gap-3">
                        <div className="flex-1 min-w-[140px] max-w-[180px]">
                          <label className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">
                            Taux de majoration ×
                          </label>
                          <input
                            type="number" step="0.05" min="0.5" max="5"
                            value={forceValidationTaux}
                            onChange={(e) => setForceValidationTaux(e.target.value)}
                            className="h-9 w-full rounded-md border border-slate-300 bg-white px-2 text-sm font-mono focus:ring-2 focus:ring-violet-300 focus:border-violet-500"
                            placeholder="1.30"
                            data-testid="force-validation-taux-input"
                          />
                        </div>

                        <button
                          type="button"
                          disabled={forceValidationLoading}
                          onClick={async () => {
                            const taux = parseFloat(String(forceValidationTaux).replace(',', '.'));
                            if (!taux || taux <= 0 || taux > 5) {
                              toast.error('Taux invalide — coefficient entre 0 et 5 (ex : 1.30)');
                              return;
                            }
                            const confirmed = window.confirm(
                              `Confirmer le forçage du REFUS ?\n\n` +
                              `Le dossier passera en ACCEPTÉ avec un taux ×${taux.toFixed(2)} ` +
                              `(soit +${((taux - 1) * 100).toFixed(0)}%).\n\n` +
                              `Cette action est tracée dans l'audit log.`
                            );
                            if (!confirmed) return;
                            setForceValidationLoading(true);
                            try {
                              const nbAct =
                                (selectedActivitesGO?.length || 0) +
                                (selectedActivites2nd?.length || 0) +
                                (selectedActivitesPIB?.length || 0) +
                                (selectedActivitesTP?.length || 0);
                              const res = await axios.post(
                                `${API}/batico/eligibility/compute`,
                                {
                                  form_data: { ...eligibilityForm, nombre_activites_batico: nbAct },
                                  cotisation_base: 1.0,
                                  famille_rcds: 'BATICO',
                                  nombre_activites: nbAct,
                                  taux_majoration_override: taux,
                                  force_validation: true,
                                },
                                { headers: getAuthHeader() },
                              );
                              if (res.data?.ok) {
                                setEligibilityResult(res.data);
                                toast.success(
                                  `✅ Validation forcée : statut ${res.data.statut} avec coef ×${taux.toFixed(2)}`,
                                  { duration: 5000 }
                                );
                                // Recalcul tarifaire automatique avec le nouveau coef
                                handleCalculer();
                              } else {
                                toast.error(`Erreur : ${JSON.stringify(res.data?.validation_errors || res.data)}`);
                              }
                            } catch (err) {
                              toast.error(err.response?.data?.detail || 'Erreur force validation');
                            } finally {
                              setForceValidationLoading(false);
                            }
                          }}
                          className="h-9 px-3 inline-flex items-center gap-1.5 bg-violet-600 hover:bg-violet-700 text-white text-sm font-semibold rounded-md shadow-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                          data-testid="force-validation-apply-btn"
                        >
                          {forceValidationLoading ? (
                            <span className="animate-spin">⏳</span>
                          ) : (
                            <span>⚖️</span>
                          )}
                          Appliquer & forcer validation
                        </button>

                        <button
                          type="button"
                          onClick={() => {
                            toast.info(
                              'Souscription en l\'état : le statut REFUS sera conservé. Utilisez les boutons « Souscrire en 1 clic » ou « Envoyer pour signature » ci-dessous.',
                              { duration: 6000 }
                            );
                            // Scroll vers les boutons de souscription
                            const submitArea = document.querySelector('[data-testid="proposition-prete-banner"]')
                              || document.querySelector('button[data-testid*="souscrire"]')
                              || document.querySelector('button[data-testid*="signer"]');
                            if (submitArea) {
                              submitArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            }
                          }}
                          className="h-9 px-3 inline-flex items-center gap-1.5 bg-white hover:bg-slate-50 text-slate-700 text-sm font-semibold rounded-md border border-slate-300 shadow-sm transition-colors"
                          data-testid="subscribe-as-is-btn"
                        >
                          📝 Souscrire en l'état
                        </button>
                      </div>
                      <p className="text-[10px] text-slate-500 italic mt-2">
                        💡 Action tracée dans <code>audit_logs</code> (action : <code>force_validation_eligibility</code>).
                      </p>
                    </div>
                  )}

                  {/* V36.62 — Affichage post-force : confirmation du REFUS overridé */}
                  {eligibilityResult.details?.refus_overridden_by_super_admin && (
                    <div
                      className="mt-4 border-l-4 border-violet-500 bg-violet-50 rounded-r-md p-3"
                      data-testid="force-validation-applied-banner"
                    >
                      <div className="flex items-center gap-2">
                        <span className="text-violet-700 text-lg">⚖️</span>
                        <div>
                          <div className="text-sm font-bold text-violet-900">
                            REFUS overridé par Super Admin
                          </div>
                          <div className="text-xs text-violet-700">
                            Coefficient appliqué : <strong>×{eligibilityResult.coefficient_dossier ?? '—'}</strong>
                            {' · '}Cotisation finale : <strong>{Number(eligibilityResult.cotisation_finale || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
        </div>

        {/* Mentions légales */}
        <div className="mt-8 bg-slate-100 p-4 rounded-lg">
          <p className="text-xs text-slate-600 leading-relaxed">
            <strong>Garantie solidaire RCD SOLIDAIRE "BATICO"</strong> - Les garanties solidaires relèvent exclusivement du champ de l'entraide associative. 
            Elle ne constitue ni une assurance, ni un convention d'indemnisation au sens du Code des assurances. 
            Elle est conforme : – à la jurisprudence du Conseil d'État, 10 février 1984 (Association d'entraide des transporteurs routiers) ; 
            – à la doctrine ACPR 2019 & 2022, reconnaissant les dispositifs de solidarité non contractuels ; 
            – et à la loi du 31 juillet 2014 relative à l'économie sociale et solidaire ; et la loi coopérative de 1947.
          </p>

            </div>
    </div>
  );
};

export default CalculateurBaticoView;
